import { useTranslation } from "react-i18next";
import { Whatsapp } from "react-bootstrap-icons";

import { TooltipWrapper } from "../TooltipWrapper";

import "./WhatsAppButton.css";

export default function WhatsAppButton() {
  const { t } = useTranslation();

  return (
    <TooltipWrapper id="whatsapp-tooltip" tooltip={t("contact.whatsappTooltip")} position="left">
      <a
        className="whatsapp-btn"
        href="#contact"
        aria-label={t("contact.whatsapp")}
      >
        <Whatsapp size="1.5rem" />
      </a>
    </TooltipWrapper>
  );
}
